<template>
    <div>
        <kgr-empty
            v-if="filteredAndSortedTiles.length === 0"
            :value="$t('Es wurden keine Ergebnisse gefunden.')"
        />

        <div
            v-else
            class="kgr-grid kgr-grid--gutters kgr-grid--inlineBlock animated fadeIn"
        >
            <div
                v-for="tile in filteredAndSortedTiles"
                class="kgr-grid__cell app-gridCard"
            >
                <div
                    v-show="tile.isEditable"
                    class="kgr-card"
                >
                    <div class="kgr-card__image kgr-card__image--full">
                        <kgr-image
                            :src="urlForListThumb(tile)"
                            :alt="tile.name"
                        />
                    </div>

                    <h3
                        v-if="tile.hierarchyPath"
                        class="kgr-card__name titleHierarchyPath"
                    >
                        {{ tile.hierarchyPath }}
                    </h3>

                    <h3 class="kgr-card__name">
                        <a :href="urlForEdit(tile)">
                            {{ tile.name }}
                        </a>
                    </h3>

                    <div class="kgr-card__contents">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import Image from '../common/Image';
import LocationImageUrlMixin from './LocationImageUrlMixin';

export default {
    name: 'KgrLocationsGrid',
    components: {
        'kgr-image': Image,
        'kgr-empty': EmptyData,
    },
    mixins: [LocationImageUrlMixin],
    props: {
        locations: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
        },
    },
    computed: {
        filteredAndSortedTiles() {
            let tiles = [];

            this.locations.forEach(location => {
                tiles.push(location);
                if (this.includeAreasAndFields) {
                    location.areas.forEach(area => {
                        tiles.push(area);
                        area.fields.forEach(field => {
                            tiles.push(field);
                        })
                    })
                }
            });

            tiles = tiles.filter(tile => {
                if (null === this.filter || '' === this.filter) {
                    return true;
                }

                const filter = this.filter.toLowerCase().trim();

                if (tile.name && tile.name.toLowerCase().includes(filter)) {
                    return true;
                }

                if (tile.hierarchyPath && tile.hierarchyPath.toLowerCase().includes(filter)) {
                    return true;
                }

                return false;
            });

            return tiles;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.small {
    font-size: 85%;
    opacity: 0.5;
}
</style>
